import {
  TRPCClientError,
  loggerLink,
  type HTTPHeaders,
  type Operation,
} from "@trpc/client";
import type { DevicePorts } from "../../runtime/ports";
import { EXPECTED_TRPC_ERROR_TYPE } from "./queryDefaults";

type HeaderDependencies = Pick<DevicePorts, "auth" | "platform"> & {
  solanaAvailable(): boolean;
};

export const createHeaders = async (
  op: Operation,
  { auth, platform, solanaAvailable }: HeaderDependencies,
) => {
  const headers: HTTPHeaders = {};

  const user = auth.currentUser();
  if (user) {
    const token = await user.getIdToken();
    if (token) {
      headers["Authorization"] = `Bearer ${token}`;
    } else {
      throw new TRPCClientError("auth.currentUser has no firebase token", {
        meta: { type: EXPECTED_TRPC_ERROR_TYPE.no_firebase_token },
      });
    }
  } else {
    const path = op.path;

    const isAuthenticatedRequest = path.split(".")?.[0] === "user";
    if (isAuthenticatedRequest) {
      if (platform.os !== "web") {
        throw new TRPCClientError("No auth.currentUser", {
          meta: { type: EXPECTED_TRPC_ERROR_TYPE.no_user_found },
        });
      }
    }
  }

  headers["App-Build-Number"] = platform.buildNumber || "";
  headers["Platform"] = platform.os || "";
  headers["App-Version"] = platform.appVersion || "";
  headers["Updates-Build-Id"] = platform.updateId || "";
  headers["Updates-Created-At"] = platform.updateCreatedAt || "";
  headers["Updates-Runtime-Version"] = platform.runtimeVersion || "";
  headers["Country-Code"] = platform.countryCode();
  headers["Supports-Solana-Wallet"] = solanaAvailable() ? "true" : "false";

  return headers;
};

export const createLoggerLink = () =>
  loggerLink({
    enabled: () => true,
    logger: (opts) => {
      if (
        ["user.accesses.claimTicket", "user.accesses.openDoor"].includes(
          opts.path,
        )
      )
        return;
      const input = opts.input
        ? `|${typeof opts.input === "object" ? JSON.stringify(opts.input) : opts.input}`
        : "";
      const direction = `${opts.direction.toUpperCase()}:`;
      const str = `${direction}${opts.path}${input}`;

      console.log(str);
    },
  });
